<template>
  <div>
    <div v-if="listData.length > 0">
      <div class="daohang">
        <!-- 课程名称 -->
        <div class="class-name">
          <span style="font-weight: 600" class="span2">
            {{ classInfo && classInfo.course_name ? classInfo.course_name : '' }}
          </span>
        </div>
        <!-- 筛选条件 -->
        <div class="flexs">
          <el-select v-if="classInfo && classInfo.cate === 2" style="margin-right: 10px" v-model="classValue"
            placeholder="课程" size="small" @change="changeClass(classValue)">
            <el-option v-for="item in classInfo.courses" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <select-date :type="0" :course_id="classValue" @change-date="changeData"></select-date>
        </div>
      </div>

      <!-- 板书列表 -->
      <board :listData="listData" @editName="editName">
        <template slot-scope="{data}">
          <div class="board-describe">
            <div class="board-name">{{ data.name }}</div>
            <div class="board-date">
              <span>{{ data.date }}</span>
              <span>{{ data.week }}</span>
              <span class="board-count"><img src="@/assets/imgs/icon-board.png" alt=""> {{ data.pages.length
              }}</span>
            </div>
          </div>
        </template>
      </board>
      <Dialog v-if="isShowDialog" :isShow="isShowDialog" @closeDialog="closeDialog" @confirm="confirm">
        <template #container>
          <el-input v-model="board_name"></el-input>
        </template>
      </Dialog>

      <!-- 分页 -->
      <el-pagination hide-on-single-page background layout="prev, pager, next" :total="pagination.total"
        :current-page="pagination.page" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-size="pagination.perPage">
      </el-pagination>
    </div>
    <!-- 无数据 -->
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>

<script>
const cityOptions = ["上海", "北京", "广州", "深圳"]
import { mapState } from 'vuex'
import SelectDate from '../../../components/filterComponent/SelectDate.vue'
import Board from './components/Board.vue'
import Dialog from '../../../components/dialog/Dialog.vue'
export default {
  components: { SelectDate, Board, Dialog },
  data () {
    return {
      classValue: this.$store.state.classInfo.course_id, // 课程id
      classOptions: [], // 课程选项
      value1: '',
      listData: [], // 板书列表
      board_id: "", // 板书id
      isShowDialog: false, // 是否显示编辑名称的弹窗
      board_name: '', // 板书集名称
      before_update_name: '', // 修改之前的板书名称
      boardId: '', // 板书集id
      pagination: {},

      checkedCities: [], // 是否选中删除
      cities: cityOptions,
      isIndeterminate: true,
      checkFlag: false,
      del_list: [],
      pages: [],
    }
  },
  computed: {
    ...mapState({
      lesson: state => state.lesson,
      classInfo: state => state.classInfo
    }),
  },
  watch: {
    board_id (newName, oldName) {
      this.board_id = newName
    },
    'classInfo.id' (val, oldVal) {
      this.value1 = ''
      this.classValue = this.classInfo.course_id
      // this.classValue = val
      this.writingData()
    }
  },
  mounted () {

    // 列表数据
    this.writingData()
    // 课程列表
    // this.changeClassName()
    // 获取课程名称
    // this.getClassName()
  },
  methods: {
    // 分页
    handleSizeChange (val) {
      this.pagination.total = val
      this.writingData()
    },
    handleCurrentChange (val) {
      this.pagination.page = val
      this.writingData()
    },
    // 删除
    delWriting () {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post("/base/board/batch/del", {
              board_ids: this.del_list,
            })
            .then((res) => {
              if (res.data.errCode == 0 && res.status == 200) {
                this.writingData()
                this.checkFlag = false
                this.$message({
                  type: "success",
                  message: res.data.message,
                })
                this.writingData()
                // this.checkFlag = false;
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    // 单选
    handleCheckedCitiesChange (value) {
      this.del_list = value
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length
    },
    // 全选
    handleCheckAllChange (val) {
      this.checkedCities = val ? cityOptions : []
      this.isIndeterminate = false
    },
    // 历史板书
    changeData (val) {
      if (val) {
        this.getDayList(val)
      } else {
        this.writingData()
      }
    },
    // 获取某一日的板书列表
    async getDayList (date) {

      if (this.classInfo) {
        var { id, course_id } = this.classInfo
      }
      const params = {
        class_id: id,
        course_id: course_id,
        date: date,
        page: this.pagination.page,
        perPage: this.pagination.perPage,
      }
      const { data: res } = await this.$axios.post("base/board/date", params)
      if (res.errCode === 0) {
        // if (res.data.length > 0) {
        this.listData = [res.data]
        // } else {
        //   this.listData = []
        //   this.empty = true
        // }
      } else {
        this.listData = []
      }
    },
    // 列表
    async writingData () {
      const { id } = this.classInfo
      const res = await this.$axios.post("/base/board/list", {
        class_id: id,
        course_id: this.classValue,
        page: this.pagination.page,
        perPage: this.pagination.perPage,
      })
      if (res.data.errCode == 0) {
        if (res.data.data.length === 0) {
          this.listData = []
        } else {
          this.listData = res.data.data
          this.pagination = res.data.meta.pagination
        }

      } else {
        this.classValue = 0
        this.listData = []
        // this.$message.error("请创建班级并加入")
      }
    },
    // 弹出详情列表框
    toWritingDetail (item) {
      // this.pageFlags = window.localStorage.setItem("pageFlags", true);
      this.$router.push({
        path: "/banshu/details",
        query: {
          id: item.id,
        },
      })
      // console.log(item);
      // return
      // this.board_id = item.id;
      // console.log(this.board_id);
      // this.dalogFlag = true;
      // this.writingDetail()
      // this.$refs.detail.dialogVisible = true;
    },
    // 详情数据
    async writingDetail () {
      const res = await this.$axios.post("/base/board/detail", {
        board_id: this.board_id,
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.pages = res.data.data.pages
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 课程列表数据
    async changeClassName () {
      const res = await this.$axios.post("/base/class/courses", {
        class_id: window.localStorage.getItem("class_id"),
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.classOptions = res.data.data
      } else {
        this.$message.error("请创建班级并加入")
      }
    },
    // 获取当前课程名称
    async getClassName () {
      const res = await this.$axios.post("/base/class/choose", {
        class_id: window.localStorage.getItem("class_id"),
        course_id: window.localStorage.getItem("course_id"),
      })
      if (res.status == 200 && res.data.errCode == 0) {
        // this.kechengName = res.data.data.course_name
      } else {
        this.$message.error("请创建班级并加入")
      }
    },
    // 选择课程
    changeClass (id) {
      window.localStorage.setItem("course_id", id)
      // 列表数据
      this.writingData()
      // 课程列表
      this.changeClassName()
      // 获取课程名称
      // this.getClassName()
    },

    // 编辑板书集名称
    editName (data) {
      const { id, name } = data
      this.before_update_name = name
      this.board_name = name
      this.boardId = id
      this.isShowDialog = true
    },
    // 确认修改板书集名称
    async confirm () {
      if (!this.board_name) {
        this.$message.warning('板书名称不能为空！')
        return false
      }
      if (this.before_update_name == this.board_name) {
        return false
      }
      const { data: res } = await this.$axios.post('/base/board/update', { board_id: this.boardId, name: this.board_name })
      if (res.errCode === 0) {
        this.$message.success(res.message)
        this.isShowDialog = false
        this.writingData()
      } else {
        this.$message.error(res.message)
      }
    },
    // 关闭弹窗
    closeDialog () {
      this.isShowDialog = false
    }
  }

}
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox__input {
  position: absolute;
  top: -10px;
  right: -289px;
  border-radius: 50%;
}

/deep/ .el-checkbox-group {
  position: absolute;
}

/deep/ .el-checkbox__inner::after {
  height: 15px;
  left: 8px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #e6a23c;
  border-color: #e6a23c;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e6a23c;
}

/deep/ .el-checkbox__inner {
  border-radius: 50%;
  width: 24px;
  height: 24px;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #e6a23c;
}

.flexs {
  display: flex;
  // justify-content: space-between;
  // justify-content: space-between;
}

.class-name {
  display: flex;
  margin-top: 4px;
  // display: inline-block;

  // display: flex;
  // .span1 {
  //   display: inline-block;
  //   width: 6px;
  //   height: 6px;
  //   background: #da6013;
  //   border-radius: 50%;
  //   margin-right: 8px;
  //   margin-top: 8px;
  //   vertical-align: center;
  // }

  .span2 {
    position: relative;
    display: inline-block;
    margin-left: 15px;
    vertical-align: center;
    width: 80px !important;

    &::before {
      position: absolute;
      top: 9px;
      left: -14px;
      content: '';
      width: 6px;
      height: 6px;
      background: #da6013;
      border-radius: 50%;

    }
  }
}

.daohang {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d8e2eb;
  margin-bottom: 20px;
}

.flex {
  display: flex;
  flex-flow: wrap;
}

.writing {
  // display: flex;
  margin-right: 15px;
  margin-bottom: 15px;

  .content:hover {
    box-shadow: 0 0.188679rem 0.113208rem 0 #d8e2eb;
  }

  .content {
    width: 290px;
    height: 267px;
    position: relative;
    margin: 0 15px 15px 0;
    padding: 9px;
    background: #fff;
    border-radius: 8px;
  }

  .writing-div {
    width: 100%;
    height: 195px;
    position: relative;

    .writing-data {
      background-image: linear-gradient(to top,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.5));
      position: absolute;
      padding: 12px 12px;
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      color: #fff;

      .number {
        display: flex;
      }

      img {
        // position: absolute;
        width: 20px;
        height: 20px;
        display: inline-block;
        // right: 35px;
        margin-right: 4px;
        // margin-top: 5px;
      }
    }

    .writing-list {
      margin-top: 6px;
      height: 57px;
      display: flex;
      justify-content: space-between;

      img {
        display: block;
        height: 57px;
        width: 89px;
      }
    }
  }

  position: relative;

  img {
    width: 100%;
    height: 100%;
    // border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Panel/banshu/index.vue